<script lang="ts">
	import { Icon } from '@steeze-ui/svelte-icon';
	import { XMark } from '@steeze-ui/heroicons';

	export let open = false;
	export let allowClose = true;
	export let allowClickAway = true;
	export let showX = true;

	const onCloseRequested = () => {
		if (allowClose && isOpen) {
			open = false;
		}
	};

	const onClickAway = () => {
		if (allowClickAway) {
			onCloseRequested();
		}
	};

	let dialog: HTMLDialogElement;
	let isOpen = false;
	$: if (dialog && open !== isOpen) {
		if (open) {
			dialog.showModal();
			isOpen = true;
		} else {
			dialog.close();
			isOpen = false;
		}
	}
</script>

<dialog
	on:click={() => {}}
	on:mousedown={onClickAway}
	on:keypress={onClickAway}
	on:close
	bind:this={dialog}
	class="rounded-xl border-2 border-accent bg-black/80 p-0 text-base-content backdrop-blur-lg"
>
	{#if showX}
		<button
			on:click={onCloseRequested}
			class="ring-none absolute right-1 top-1 h-6 w-6 rounded-md text-base-content outline-none focus-visible:bg-primary"
		>
			<Icon src={XMark} />
		</button>
	{/if}
	<div
		class="p-8"
		on:mousedown|stopPropagation
		on:click|stopPropagation
		on:keypress|stopPropagation
	>
		<slot />
	</div>
</dialog>

<style>
	dialog::backdrop {
		overflow: visible;
		backdrop-filter: blur(4px);
		animation: filter-animate 0.3s ease-in-out;
	}
	dialog[open] {
		animation: toggle-dialog 0.3s ease-in-out;
	}

	@keyframes filter-animate {
		from {
			backdrop-filter: blur(4px) opacity(0);
		}

		to {
			backdrop-filter: blur(4px) opacity(1);
		}
	}

	@keyframes toggle-dialog {
		from {
			opacity: 0;
		}

		to {
			opacity: 1;
		}
	}
</style>
